import { connect } from "react-redux"
import deepmerge from "deepmerge"

import appStore from "stores/appStore"
import authStore from "stores/authStore"
import BenefitInsuranceStore from "stores/benefitInsuranceStore"
import PreviousBenefitInsuranceStore from "stores/previousBenefitInsuranceStore"

const storeMapping = {
  appStore,
  authStore,
  BenefitInsuranceStore,
  PreviousBenefitInsuranceStore,
}

const withStores = (mapStoresToProps) =>
  connect((state, props) => {
    const stores = deepmerge(storeMapping, state.data, { clone: false })
    return mapStoresToProps(stores, props)
  })

export default withStores
